require('./currencyDropdown.scss');

// @ vendors
const React = require('react');
const PropTypes = require('prop-types');
// @ commons
const { formatText, FormattedText } = require('core/i18n').i18n;
const OKSelect = require('components/commons/OKSelect/OKSelect');
// @ constants
const { CURRENCIES, currenciesOptions } = require('constants/currencies');
const { EURO_TEXT } = require('constants/index');
// @ components
const optionComponent = require('./currencyDropdownOptionComponent');
const valueComponent = require('./currencyDropdownValueComponent');

class CurrencyDropdown extends React.Component {

    render() {
        const { onChange, value, openUp } = this.props;

        const options = [{
            label: formatText('currencyFilter-moreUsed'),
        }, {
            value: EURO_TEXT,
            label: formatText('currency-EUR')
        }, {
            value: CURRENCIES['USD'],
            label: formatText('currency-USD')
        }, {
            label: formatText('currencyFilter-otherCurrencies'),
        }];

        currenciesOptions().forEach((currency) => {
            options.push(currency);
        });

        return (
            <article className="currency-dropdown">
                <h3 className="currency-dropdown__title">
                    <FormattedText value="currencyFilter-currency" />
                </h3>
                <section className="row">
                    <div className="col-xs-6">
                        <OKSelect
                            name="currency-dropdown-dropdown"
                            className="currency-dropdown__dropdown"
                            onChange={onChange}
                            value={value}
                            optionComponent={optionComponent}
                            valueComponent={valueComponent}
                            options={options}
                            openUp={openUp}
                            searchable={false}
                            clearable={false}
                        />
                    </div>
                </section>
            </article>
        );
    }
}

CurrencyDropdown.propTypes = {
    value: PropTypes.string,
    onChange: PropTypes.func.isRequired,
    openUp: PropTypes.bool
}

CurrencyDropdown.defaultProps = {
    openUp: false
}

module.exports = CurrencyDropdown;
